export function setupDisturbancePanel() {
  /** @type {HTMLDivElement} */
  const component = document.querySelector('.disturbance');
  /** @type {HTMLButtonElement} */
  const toggleButton = document.querySelector('.disturbance__toggle');
  /** @type {HTMLButtonElement} */
  const closeButton = document.querySelector('.disturbance__close');

  function handleClickOutside(event) {
    if (component.contains(event.target)) {
      return;
    }
    handleToggleDisturbance();
  }

  function handleToggleDisturbance() {
    document.addEventListener('click', handleClickOutside);

    if (component !== null) {
      component.classList.toggle('disturbance--open');

      if (component.classList.contains('disturbance--open')) {
        toggleButton.setAttribute('aria-expanded', 'true');
        closeButton.focus({ focusVisible: true });
      } else {
        toggleButton.setAttribute('aria-expanded', 'false');
        document.removeEventListener('click', handleClickOutside);
      }
    }

  }

  toggleButton?.addEventListener('click', handleToggleDisturbance);
  closeButton?.addEventListener('click', handleToggleDisturbance);
}
